import { createStore, createHook } from 'react-sweet-state';
import api from '../services/api';

const Store = createStore({
  // value of the store on initialisation
  initialState: {
    user: null,
    novels: [],
    currentNovel: null,
    readOnly: true,
  },
  // actions that trigger store mutation
  actions: {
    setUser:
      (user) =>
      ({ setState }) => {
        setState({ user });
      },
    setNovels:
      (novels) =>
      ({ setState }) => {
        setState({ novels });
      },
    setCurrentNovel:
      (currentNovel) =>
      ({ setState }) => {
        setState({ currentNovel });
      },
    setReadOnly:
      (readOnly) =>
      ({ setState }) => {
        setState({ readOnly });
      },
    addMessageToChat:
      (chatId, message) =>
      async ({ getState, setState }) => {
        const state = getState();
        try {
          const updatedChats = state.currentNovel?.chats?.map(chat =>
            chat.id === chatId
              ? { ...chat, messages: [...(chat.messages || []), message] }
              : chat
          );
          setState({
            currentNovel: {
              ...state.currentNovel,
              chats: updatedChats,
            },
          });

          return { success: true };
        } catch (error) {
          console.error('Error adding message to chat:', error);
          return { success: false, error };
        }
      },
      
    updateChatMessages: 
      (chatId, newMessages) => 
      async ({ getState, setState }) => {
        const state = getState();
        try {
          // Only proceed if we have a current novel
          if (!state.currentNovel) return { success: false, error: 'No current novel' };
          
          // Update the specific chat with new messages
          const updatedChats = state.currentNovel.chats?.map(chat =>
            chat.id === chatId
              ? { ...chat, messages: newMessages }
              : chat
          );
          
          // Update the state
          setState({
            currentNovel: {
              ...state.currentNovel,
              chats: updatedChats
            }
          });
          
          return { success: true };
        } catch (error) {
          console.error('Error updating chat messages in store:', error);
          return { success: false, error };
        }
      },
    updateUserSettings:
      (settings) =>
      async ({ getState, setState }) => {
        const state = getState();
        try {
          const userId = state.user.id;
          await api.updateUserSettings(userId, settings);

          // Update the local user state with the new settings
          setState({
            user: {
              ...state.user,
              settings,
            },
          });

          return { success: true };
        } catch (error) {
          console.error('Error updating user settings:', error);
          return { success: false, error };
        }
      },
  },
  // optional, unique, mostly used for easy debugging
  name: 'counter',
});

export const useStore = createHook(Store);